import { UserPermissions } from "@/utils";

const getters = {
  loading: (state) => state.app.loading,
  drawer: (state) => state.app.drawer,
  isProduction: (state) => state.app.production,
  token: (state) => state.user.token,
  user: (state) => state.user,
  isAdminUser: (state) => state.user.access === 0,
  actions: (state) => state.user.access,
  permissionRoutes: (state) => state.permission.routes,
  lastRoute: (state) => state.permission.lastRoute,
  actionsAccess: function(state) {
    return {
      INVENTARY: [UserPermissions.ADMIN, UserPermissions.USER].includes(state.user.access),
      Admin: [UserPermissions.ADMIN].includes(state.user.access),
    }
  },

  zebraIsConnected: (state) => state.zebra.isConnected,
  zebraSelectedReader: (state) => state.zebra.selectedReader,
  zebraReadTags: (state) => state.zebra.readTags,
  zebraInventoryState: (state) => state.zebra.inventoryState,
  zebraTagLocateState: (state) => state.zebra.tagLocateState,
  zebraPercentageLocate: (state) => state.zebra.percentageLocate,
  zebraReaders: (state) => state.zebra.readers,
  zebraConfig: (state) => state.zebra.config,
  zebraDeviceInfo: (state) => state.zebra.deviceInfo
}

export default getters;
